import { SizeGuidePage } from '@/app/pages/SizeGuidePage';

export function ResponsiveSizeGuidePage() {
  return <SizeGuidePage />;
}
